<template>
<div class="mx-auto" style="width:600px;">
    <h3 @click="clickTitle">Sports Participation</h3>
    <p>Most modern theories of learning recognize the fact that learning
    does not take place in a vacuum. Individual knowledge, memory,
    along with situational variables can greatly impact the learning process.
    In order to facilitate our research on causal learning we are interested
    in knowing certain factors about you, the learner. Specifically, we are
    interested in whether you actually take the time to read the directions;
    if not, then some of our manipulations that rely on changes in the
    instructions will be ineffective. So, in order to demonstrate that
    you have read the instructions, please ignore the sports items below,
    as well as the continue button. Instead, simply click on the title at
    the top of this screen(i.e., "participation") to proceed to the next
    screen. Thank you very much.
    </p>
    <b-form-group>
    <h5 class="text-left">Which of these activities do you engage in
         regularly?(click on all that apply)</h5>
      <b-form-checkbox-group id="checkbox-sport" v-model="sports" name="sport">
      <b-form-checkbox value="skiing">
          skiing
          </b-form-checkbox>
      <b-form-checkbox value="soccer">
          soccer
          </b-form-checkbox>
      <b-form-checkbox value="snowboarding">
          snowboarding
          </b-form-checkbox>
      <b-form-checkbox value="running">
          running
          </b-form-checkbox>
      <b-form-checkbox value="hockey">
          hockey
          </b-form-checkbox><br>
      <b-form-checkbox value="football">
          football
      </b-form-checkbox>
      <b-form-checkbox value="tennis">
          tennis
          </b-form-checkbox>
      <b-form-checkbox value="basketball">
          basketball
          </b-form-checkbox>
      <b-form-checkbox value="cycling">
          cycling
      </b-form-checkbox>
      <b-form-checkbox value="notlist">
          Not listed here
      </b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>
    <b-button
    class="rounded-pill"
    variant="danger"
    @click="clickContinue">
    Continue</b-button>
    <br />
</div>
</template>
<style scoped>
h3{
    padding:10px;
}
p{
text-align: left;
}
</style>
<script>
import axios from 'axios';
// import Alert from '../Other/Alert.vue';

export default {
  name: 'IMC',
  data() {
    return {
      sports: [],
      passcheck: null,
      showAlert: false,
      msg: '',
      taskID: '',
    };
  },
  // components: {
  //   alert: Alert,
  // },
  methods: {
    startTask() {
      const path = `${this.$hostname}/submit-imc/${this.taskID}`;
      const payload = {
        passcheck: this.passcheck,
        sports: this.sports,
      };
      axios
        .put(path, payload)
        .then((res) => {
          console.log(res.data.isLoggedIn);
          if (!res.data.isLoggedIn) {
            this.$router.push({ name: 'Login' });
          } else {
            localStorage.taskProgress = 'Introduction';
            this.$router.push({ name: 'Task' });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          this.showAlert = true;
          this.msg = 'Server Error';
          console.error(error);
        });
    },
    clickContinue() {
      this.passcheck = 0;
      this.startTask();
    },
    clickTitle() {
      this.passcheck = 1;
      this.startTask();
    },
  },
  created() {
    this.taskID = localStorage.taskID;
    if (localStorage.taskProgress !== 'IMC') {
      this.$router.push({ name: 'Task' });
    }
  },
};
</script>
